import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { FileDownloadUrlResponse } from '@/repositories/generated';

const response: FileDownloadUrlResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['ユーザID', '外部ユーザID', '決済手段ID', '付与数', '有効期限'],
    ['1', '1', '1', '1', '2023-01-01'],
  ]),
};

export const bulkGrantOriginalDownload = http.get(
  createMockEndpoint('/bulk_grant/:id/download/original'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
